/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.QuickbooksDesktop {
    'use strict';

    import IModalService = Meevo.Components.Modal.IModalService;

    enum QuickbooksDesktopLogTypeEnum {
        Sync,
        Delete
    }

    enum QuickbooksDesktopLogTransactionStatus {
        Error,
        Success
    }

    interface IQuickbooksDesktopLogRequest {
        criteria?: any;
        itemsPerPage: number;
        clientGlobalId?: string;
        asLocationId?: number;
        sortBy?: string;
        sortDirection?: Model.SortDirection
    }

    interface IParams {
        startDate: Date,
        endDate: Date,
        employeeId: number,
        actionTypes: Array<any>,
        applicationConnectionId: string,
        filter: string,
        maintenanceMode: boolean,
        isGlobal: boolean,
    }

    interface ILogsInformation {
        itemsAdded: number;
        invoices: number;
        creditMemos: number;
    }

    class LogsController {
        public arrayResults: Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;

        public params: IParams = {
            startDate: moment().startOf('day').toDate(),
            endDate: moment().add(1, 'day').startOf('day').subtract(1, 'm').toDate(),
            employeeId: null,
            actionTypes: [],
            applicationConnectionId: null,
            filter: null,
            maintenanceMode: true,
            isGlobal: true
        }
        public request: IQuickbooksDesktopLogRequest = {
            criteria: this.params,
            itemsPerPage: 25,
            sortBy: 'actionStartDateTime',
            sortDirection: Model.SortDirection.Descending
        };
        public logsInfromationData: ILogsInformation = {
            itemsAdded: 2,
            invoices: 15,
            creditMemos: 2
        };
        public employee: any; // TODO: add type
        public filterSync: boolean;
        public filterDelete: boolean;        

        static $inject = [
            'meevo.components.modal.ModalService',
            'meevo.components.common.DataService',
            '$translate',
            '$scope'
        ];

        constructor(
            private modalService: IModalService,
            private dataService: Components.BaseClasses.IDataService,
            protected $translate: angular.translate.ITranslateService,
            protected $scope: angular.IScope
        ) { }

        $onInit(): void {
            this.getLogList();
            this.$scope.$on('selectLogsTab', this.getLogList.bind(this));
        }

        getResults(url: string, onPageLoad: Function) {
            return new Meevo.Components.BaseClasses.PagedResults(this.dataService, url, onPageLoad);
        }

        /**
         * Load List of Logs
         */
        getLogList(): void {
            let request: IQuickbooksDesktopLogRequest = angular.copy(this.request),
                url: string = 'AccountSyncDesktop/Log';

            this.arrayResults = this.getResults(url, null);
            this.arrayResults.initSearch(request);
        }

        /**
         * Filter results by filter criteria
         * @param connection
         */
        applyFilter(connection?): void {
            let request: IQuickbooksDesktopLogRequest = angular.copy(this.request);

            if (connection && connection !== 'none') {
                request.criteria.applicationConnectionId = this.request.criteria.applicationConnectionId = connection.applicationConnectionId;
            }
            if (connection === 'none') {
                request.criteria.applicationConnectionId = this.request.criteria.applicationConnectionId = null;
            }
            if (this.employee) {
                request.criteria.employeeId = this.employee.id;
            }

            this.arrayResults.initSearch(request);
        }

        /**
         * Clearing criteria of filter
         * */
        clearAdvancedSearch(): void {
            this.params.actionTypes = [];
            this.employee = null;
            this.applyFilter();
        }

        /**
         * Open filter in modal
         * */
        showFilter(): void {
            const context = this;
            this.modalService.showCustom({
                templateUrl: 'app/plugins/accountsync/components/logs/logs.advFilters.template.html',
                controller: 'meevo.components.controls.ModalContextController',
                controllerAs: 'ctrl',
                clickOutsideToClose: true,
                locals: {
                    context: context
                }
            });
        }

        /**
         * Click on filter criteria Sync
         * */
        onSyncClicked(): void {
            if (this.filterSync) {
                this.params.actionTypes.push(QuickbooksDesktopLogTypeEnum.Sync);
            } else {
                let position = this.params.actionTypes.indexOf(QuickbooksDesktopLogTypeEnum.Sync);
                if (~position) {
                    this.params.actionTypes.splice(position, 1);
                }
            }
        }

        /**
         * Click on filter criteria Delete
         * */
        onDeleteClicked(): void {
            if (this.filterDelete) {
                this.params.actionTypes.push(QuickbooksDesktopLogTypeEnum.Delete);
            } else {
                let position = this.params.actionTypes.indexOf(QuickbooksDesktopLogTypeEnum.Delete);
                if (~position) this.params.actionTypes.splice(position, 1);
            }
        }

        /**
         * Check if needed show errors
         * @param {any} logItem
         * @returns {boolean}
         */
        private isErrorInLog(logItem: any): boolean {
            if (!logItem || !logItem.details.length) return false;
            return !!logItem.details.find(el => el.transactionStatus === QuickbooksDesktopLogTransactionStatus.Error);
        }

        /**
         * Returned the amount of current Api Type
         * @param {any} logItem
         * @param {string} apiType
         * @returns {number}
         */
        private getCountOfApiType(logItem, apiType: string): number {
            if (!logItem || !logItem.details.length) return 0;

            return logItem.details.filter(el => el.apiType === apiType).length;
        } 

        /**
         * Returned the array of Api Names
         * @param {any} logItem
         * @param {string} apiType
         * @returns {any}
         */
        private getApiNames(logItem): any {
            if (!logItem || !logItem.details.length) return [];

            return _.unique(logItem.details.map(el => el.apiType));
        }

        /**
         * Returned the array of Qb Error 
         * @param {any} logItem
         * @returns {string[]}
         */
        private getQbApiErrors(logItem): string[] {
            if (!logItem || !logItem.details.length) return [];

            return logItem.details.filter(el => el.transactionStatus === QuickbooksDesktopLogTransactionStatus.Error).map(el => {
                return this.$translate.instant('TEXT_QB_RETURNED_ERROR',
                    {
                        accountName: el.apiType,
                        errorException: el.notes
                    }); 
            });
        }

        //get accountSyncLogTypeEnum(): any {
        //    return QuickbooksDesktopLogTypeEnum;
        //}

        get syncActionTypeEnum() {
            return SyncActionTypeEnum;
        }
    }

    class LogsComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/quickbooksDesktop/components/logs/logs.template.html';
        controller = LogsController;
        controllerAs = 'vm';
        bindings: any = { };
    }

    angular.module('meevo.plugins.quickbooksDesktop')
        .component('quickbooksDesktopLogsComponent', new LogsComponent());

}

